import React from "react";
import {DatePicker, Form, message, Modal, Select, Spin} from "antd";
import {UserList} from "../../../../models/employee";
import {TruckList} from "../../../../models/truck";
import {QueueGet, QueueUpdate} from "../../../../models/queue";
import {MemberRolesPost, MemberRolesRemove} from "../../../../models/dispatchMemberRole";

const FormItem = Form.Item;
const Option = Select.Option;
const moment = require('moment');

export class AssignTruckTeamForm extends React.Component {
  state = {
    team_data: [],
    truck_data: [],
    team_value: [],
    roles: [],
    confirmLoading: false,
    service_date: this.props.data.service_date,
  };
  handlePopupAfterAddUpdate = () => {
    this.props.fetch(this.props.params);
    this.props.setModelVisible()
  };
  fetchTeamMember = (value = '') => {
    this.setState({fetching: true});
    const requestData = {'search': value, 'ids': ['driver', 'laborer'], 'related_field': 'user_type'};
    UserList(requestData)
      .then(body => {
        const role = this.state.roles.map(item => item.member_id);
        let team_data = body.data.results.filter(item => !role.includes(item.id))
          .map(member => ({
            text: `${member.first_name} ${member.last_name}`,
            value: member.id
          }));
        this.setState({team_data, fetching: false});
      });
  };
  fetchTruck = (value = '') => {
    this.setState({truck_data: [], fetching: true});
    const requestData = {'search': value, 'ids': this.props.data.trucks.join(','), 'related_field': 'type_id'};
    TruckList(requestData)
      .then(body => {
        const truck_data = body.data.results.map(truck => ({
          text: `Truck ID: ${truck.truck_id} | ${truck.type ? truck.type.type_name : ''}`,
          value: truck.id
        }));
        this.setState({truck_data, fetching: false});
      });
  };
  handleTeamChange = (value) => {
    this.setState({
      team_value: value,
      fetching: false
    });
  };
  handleTruckChange = (value) => {
    this.setState({
      truck_value: value,
      fetching: false
    });
  };

  handleAssignTD = () => {
    const form = this.props.form;
    const roles = this.state.roles;
    form.validateFields(['truck', 'service_date'], (err, values) => {
      if (!roles.length) {
        err = "One Crew members must be selected";
        message.error(err);
      } else if (this.props.data.number_people && roles.length < this.props.data.number_people) {
        err = "Number of assigned team should be equal team members";
        message.error(err);
      }
      if (!err) {
        this.setState({confirmLoading: true});
        values['truck'] = values.truck.key;
        values['service_date'] = values.service_date.format('YYYY-MM-DD');
        values['members'] = roles.map(role => role.id);
        QueueUpdate(this.props.data.service_id, values)
          .then(response => {
            message.success('Truck and Team added in service successfully');
            this.handlePopupAfterAddUpdate();
            this.setState({
              roles: []
            });
            this.setState({confirmLoading: false})
          })
      }
    })
  };
  onRowUpdateClick = (id) => {
    QueueGet(id)
      .then(response => {
        this.handleTruckChange({
          key: response.data.truck.id,
          label: `Truck ID: ${response.data.truck.truck_id} | ${response.data.truck.type.type_name}`
        });
        this.setState({
          roles: response.data.members.map(row => {
            return ({id: row.id, role: row.role, member: `${row.member.first_name} ${row.member.last_name}`})
          })
        });
      });
  };

  handleDateChange = (value) =>{
    this.setState({service_date:value.format("YYYY-MM-DD")})
  };

  componentDidMount() {
    const {visible, data} = this.props;
    if (data.update && visible)
      this.onRowUpdateClick(data.service_id)
  }

  addMemberRoles = () => {
    const form = this.props.form;
    const roles = this.state.roles;
    form.validateFields(['member', 'role'], (err, values) => {
      if (!err) {
        MemberRolesPost({member: values.member.key, role: values.role.key})
          .then(response => {
            response.member_id = response.member;
            response.member = values.member.label;
            roles.push(response);
            this.setState({
              roles: roles
            });
          });
      }
    })
  };
  removeMemberRoles = (index) => {
    let roles = this.state.roles;
    MemberRolesRemove(index);
    roles = roles.filter(role => role.id !== index);
    this.setState({roles})
  };

  render() {
    const {visible, data} = this.props;
    const {getFieldDecorator} = this.props.form;
    const {team_data, truck_data, truck_value, team_value, fetching, roles, confirmLoading, service_date} = this.state;
    return (
      <Modal title="Select Truck & Team" confirmLoading={confirmLoading} centered visible={visible}
             onOk={this.handleAssignTD} onCancel={() => this.props.setModelVisible()} className="select-TD-mdl"
             width="45%">
        <div className="row">
          <div className="col-12 m-b-20">
            <FormItem label="Dispatch Date">
              {getFieldDecorator('service_date', {
                initialValue: moment(service_date)
              })(<DatePicker onChange={this.handleDateChange} placeholder="Enter Service Date" className="drawer-datepicker w-100"/>)}
            </FormItem>
          </div>
          <div className="col-12 text-center m-b-20">
            <FormItem>
              {getFieldDecorator('truck', {
                initialValue: truck_value,
                rules: [{required: true, message: 'Please select truck'}],
              })(<Select labelInValue showSearch notFoundContent={fetching ? <Spin size="small"/> : null}
                         placeholder="Select Truck" onChange={this.handleTruckChange} onSearch={this.fetchTruck}
                         onFocus={this.fetchTruck} style={{width: "100%"}}>
                {truck_data.map(d => (<Option className="opt-style-td" key={d.value}>{d.text}</Option>))}
              </Select>)}
            </FormItem>
          </div>
          <div className="col-sm-5 col-12 text-center">
            <FormItem>
              {getFieldDecorator('member', {
                // initialValue: team_value,
                rules: [{required: true, message: 'Please select Crew members'}],
              })(<Select labelInValue allowClear filterOption={false} showSearch placeholder="Select Crew members" onChange={this.handleTeamChange}
                         onSearch={this.fetchTeamMember} onFocus={this.fetchTeamMember} style={{width: "100%"}}>
                {team_data.map(d => (<Option className="opt-style-td" key={d.value}>{d.text}</Option>))}
              </Select>)}
            </FormItem>
          </div>
          <div className="col-sm-5 col-12 text-center">
            <FormItem>
              {getFieldDecorator('role', {
                rules: [{required: true, message: 'Please select Crew members'}],
              })(<Select labelInValue mode="default" placeholder="Select member role" optionFilterProp="children"
                         style={{width: "100%"}}>
                <Option value="laborer">LABORER</Option>
                <Option value="driver">Driver</Option>
              </Select>)}
            </FormItem>
          </div>
          <div className="col-sm-2 col-12 text-center td-add-btn">
            <button type="button" onClick={() => this.addMemberRoles()} className="btn ant-btn-primary">Add</button>
          </div>
        </div>
        <div className="row added-td-popup td-pop-header">
          <div className="col-sm-5">
            <p>Name</p>
          </div>
          <div className="col-sm-5">
            <p>Role</p>
          </div>
          <div className="col-sm-2">
            <p>Action</p>
          </div>
        </div>
        {roles.map((row) => {
          return <div key={row.id} className="row added-td-popup td-pop-content">
            <div className="col-sm-5">
              <p>{row.member}</p>
            </div>
            <div className="col-sm-5">
              <p>{row.role}</p>
            </div>
            <div className="col-sm-2">
              <button type="button" className="btn td-trash" onClick={() => this.removeMemberRoles(row.id)}><i
                className="fa fa-trash"/></button>
            </div>
          </div>
        })}
      </Modal>
    )
  }
}

export const AssignTruckTeam = Form.create()(AssignTruckTeamForm);



// WEBPACK FOOTER //
// ./src/pages/dispatch/queue/popup/AssignTruckTeam.jsx